import { render, staticRenderFns } from "./TicketsGenerated.vue?vue&type=template&id=4d8b412c&scoped=true&"
import script from "./TicketsGenerated.vue?vue&type=script&lang=js&"
export * from "./TicketsGenerated.vue?vue&type=script&lang=js&"
import style0 from "./TicketsGenerated.vue?vue&type=style&index=0&id=4d8b412c&scoped=true&lang=css&"
import style1 from "../../assets/css/style-tables-dark.css?vue&type=style&index=1&id=4d8b412c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8b412c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAlert,VBadge,VBtn,VDataTable,VIcon,VSimpleTable})
